module.exports = __webpack_public_path__ + "img/pattern-brick.b5afd0d0.svg";